import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'No creía que una faja pudiera cambiar tanto. Lo que más me sirvió fue la guía de masajes, en una semana me sentí mucho más liviana. La calidad es excelente, nada que ver a las que compraba antes.',
    author: 'María L.',
    location: 'Córdoba',
    result: 'Bajó 5cm en 18 días'
  }, {
    quote: 'Chicas, es un viaje de ida. La uso mientras trabajo en la compu y siento cómo trabaja el calor. El material es súper grueso y no se marca en la ropa. Llegó rapidísimo a Palermo.',
    author: 'Luciana R.',
    location: 'CABA',
    result: 'Chau inflamación post-comidas'
  }, {
    quote: 'Después de mis dos embarazos me costaba horrores bajar la panza. Este kit me ordenó. El protocolo es súper claro y la faja te sostiene re bien la postura también. ¡Recomendadísimo!',
    author: 'Valentina S.',
    location: 'Rosario',
    result: 'Recuperó su talle pre-mamá'
  }];
  return <section className="py-20 px-4 md:px-8 bg-rose/20" data-id="element-167">
      <div className="max-w-6xl mx-auto" data-id="element-168">
        <div className="text-center mb-16" data-id="element-169">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brown-deep mb-4" data-id="element-170">
            Ellas ya lograron su Efecto Vacío
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-171">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow flex flex-col" data-id="element-172">
              <div className="flex gap-1 mb-4" data-id="element-173">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold text-gold" data-id="element-174" />)}
              </div>
              <p className="text-brown-medium italic mb-6 flex-grow" data-id="element-175">
                "{t.quote}"
              </p>
              <div className="mt-auto" data-id="element-176">
                <div className="font-bold text-brown-deep" data-id="element-177">{t.author}</div>
                <div className="text-sm text-gray-500 mb-3" data-id="element-178">{t.location}</div>
                <div className="inline-block px-3 py-1 bg-green-100 text-green-800 text-xs font-bold rounded-full" data-id="element-179">
                  {t.result}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}